// Configuration and internationalization settings
const config = window.wishlist.config;
const i18n = window.wishlist.i18n;

let current_products = [];

/**
 * Fetches and renders product cards for the given products.
 *
 * @param {Array} products - The list of products to fetch and render.
 */
async function fetchProductCards(products) {
    let collectionProducts = false;
    let productCards = await Promise.all(
        products.map(async (product) => {
            if (product.du) {
                return await theme.renderProductCard({
                    url: product.du,
                    handle: product.du.split("/products/")[1].split("?")[0],
                    variant: `variant=${product.epi}`,
                }, "", "product-card-wishlist");
            }
            collectionProducts = true;
            return await theme.renderProductCard({
                url: product.url,
                handle: product.handle,
                variant: `variant=${product.variants[0].id}`,
            }, "", "product-card");
        }),
    );

    let title = i18n.wishlist_empty;
    if (productCards.length > 0 && !collectionProducts) {
        title = i18n.wishlist + '(' + (productCards.length > 1 ? i18n.wishlist_products.other.replace(`{{ count }}`, productCards.length) : i18n.wishlist_products.one) + ')';
    }
    document.querySelector('.wishlist__title').innerHTML = title;
    document.querySelector('.wishlist__product-items-container').innerHTML = productCards.join('');
}

// Event listener for Swym initialization
document.addEventListener("swat-initialized", () => {
    if (window._swat) {
        window._swat.fetch(
            function (allWishlistedProducts) {
                if (allWishlistedProducts.length > 0) {
                    const products = allWishlistedProducts;
                    current_products = products;
                    fetchProductCards(products);
                } else {
                    products = config.fallbackCollection.products.slice(0, config.fallbackCollection.limit);
                    current_products = products;
                    fetchProductCards(products);
                    if (config.fallbackCollection.products.length < 1) console.error('No Fallback Collection provided. Please provide a collection with products.');
                }
            },
            function (error) {
                console.log("There was an error while fetching the wishlist", error);
            }
        );
    }

    // Event listener for removing a product from the wishlist
    document.addEventListener("remove-product-from-wishlist", (e) => {
        const product = e.detail;

        // Show loader before removing product from wishlist
        const handleLoading = (product) => {
            const wishListIconTemplateLoading = document.querySelector('[data-wishlist-icon="loading"]');
            document.querySelectorAll(`[data-wishlist-icon-id="${product.epi}"]`).forEach(el => {
                el.innerHTML = '';
                el.appendChild(document.importNode(wishListIconTemplateLoading.content, true));
            });
        }

        handleLoading(product);

        window._swat.removeFromWishList(product, () => {
            // Unmark the wishlist icon and set the empty wishlist icon
            const wishListIconTemplateEmpty = document.querySelector('[data-wishlist-icon="empty"]');
            document.querySelectorAll(`[data-wishlist-icon-id="${product.epi}"]`).forEach(el => {
                el.innerHTML = '';
                el.appendChild(document.importNode(wishListIconTemplateEmpty.content, true));
            });

            // Remove card markup
            current_products = current_products.filter((product) => !(product.epi == e.detail.epi && product.empi == e.detail.empi));
            if (!current_products.length) {
                current_products = config.fallbackCollection.products.slice(0, config.fallbackCollection.limit);
            }
            fetchProductCards(current_products);
            document.dispatchEvent(new CustomEvent('swat-wishlist-updated'));
        });
    });
});
